<!--<app-sidenav [collapsed]="sideNavVisible$ | async"></app-sidenav>-->
<div class="content flex">
  <p class="govuk-body-l">You have successfully created an account.</p>
  <p><a routerLink="/home">Return to the Government Commercial Agency homepage</a></p>
</div>
